export default __webpack_public_path__ + "static/media/contact.180aec5b.svg";